import styled from 'styled-components'
import { Button } from '~/components/shared'

export const FilterButton = styled(Button).attrs((props: { width: string }) => ({
  variant: 'outlined',
  color: 'primary',
  width: props.width,
  style: { padding: 0 }
}))<{ width: string }>`
  &:not(:disabled) svg {
    margin-right: 8px;
    fill: ${props => props.theme.colors.color378ff7};
  }

  &:not(:disabled):hover svg {
    fill: ${({ theme }) => theme.zds.colors.neutral1000};
  }
`

interface ISelection {
  open: boolean
}

export const Selection = styled.div<ISelection>`
  position: absolute;
  width: 252px;
  top: calc(100% + 5px);
  left: 39%;
  transform: translateX(-50%);
  padding: 8px;

  display: ${props => (props.open ? 'block' : 'none')};
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  box-shadow: 0px 13px 30px ${props => props.theme.colors.colorBlack29};
  border-radius: 4px;
  z-index: 99;

  cursor: pointer;

  ul {
    li + li {
      margin-top: 20px;
    }
    li {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;

      label {
        span {
          cursor: pointer;
          margin-left: -8px;
          color: ${props => props.theme.colors.color6b7786};
        }
      }
    }
  }
`
